import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TemplatesService } from 'src/app/core/services/templates.service';
import { InformeErroresProcAuto, ListaDetalles } from 'src/app/models/InformeErroresProcAuto';
import { ValidadoresService } from '../../../../core/services/validadores.service';
import * as moment from 'moment';

@Component({
  selector: 'app-fallo-proc-auto',
  templateUrl: './fallo-proc-auto.component.html',
  styleUrls: ['./fallo-proc-auto.component.scss']
})
export class FalloProcAutoComponent implements OnInit {

  formulario: FormGroup;
  formularioCompletado: boolean = false;
  //Carga de resultados...
  loading: boolean = false;
  loadingCarga: boolean = false;
  mostrarError: boolean = false;
  cargandoResultados: boolean = false;
  datos: InformeErroresProcAuto = {
    resultadoErrores: 0,
    totalErrorPorDuplicado: 0,
    totalErrorPorTotales: 0,
    totalErroresPorFaltaCompania: 0,
    totalErroresPorFaltaDatos: 0,
    totalErroresPorFaltaIVA: 0,
    totalErroresPorMultiPagina: 0,
    totalErroresPorNumFactura: 0,
    listado: []
  };

  constructor(
    private fb: FormBuilder,
    private templatesService: TemplatesService,
    private validadores: ValidadoresService,
    private activatedRouter: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router
  ) {

    this.formulario = this.fb.group({
      fecha: ['', [this.validadores.fechaNoAdecuada]],
      principal: [''],
      secundario: [''],
      difTotales: [false],
      faltaDatos: [false],
      variasPaginas: [false],
      numFactura: [false],
      faltaIVAs: [false],
      faltaCIF: [false],
      duplicado: [false]
    });
  }

  ngOnInit() {
  }

  onSubmit(f: FormGroup) {
    this.formularioCompletado = false;
    this.cargandoResultados = true;

    console.log("Mostrando datos del formulario: ");
    console.log(f);

    //Carga datos...
    this.loading = true;
    this.mostrarError = false;
    var principal: string = 'vacio';
    var secundario: string = 'vacio';
    var fecha = 0;

    if (this.formulario.get('fecha').value != '') {
      fecha = this.GetFechaInteger(this.formulario.get('fecha').value);
    }

    if (this.formulario.get('principal').value != '') {
      principal = this.formulario.get('principal').value;
      principal.toLocaleUpperCase();
    }

    if (this.formulario.get('secundario').value != '') {
      secundario = this.formulario.get('secundario').value;
      secundario.toLocaleUpperCase();
    }

    //checks
    var difTotales = this.formulario.get('difTotales').value;
    var faltadatos = this.formulario.get('faltaDatos').value;
    var variasPaginas = this.formulario.get('variasPaginas').value;
    var numFactura = this.formulario.get('numFactura').value;
    var faltaIva = this.formulario.get('faltaIVAs').value;
    var faltaCif = this.formulario.get('faltaCIF').value;
    var DocDuplicado = this.formulario.get('duplicado').value;


    this.templatesService.ObtenerListadoInformesFalloProcAuto(fecha, principal, secundario,
      difTotales, faltadatos, variasPaginas, numFactura, faltaIva, faltaCif, DocDuplicado)
      .subscribe(datos => {
        this.datos = datos;

        //Recorremos listado para calcular estadística...
        this.datos.resultadoErrores = 0;
        this.datos.totalErrorPorTotales = 0;
        this.datos.totalErroresPorFaltaDatos = 0;
        this.datos.totalErroresPorMultiPagina = 0;
        this.datos.totalErroresPorNumFactura = 0;
        this.datos.totalErroresPorFaltaIVA = 0;
        this.datos.totalErroresPorFaltaCompania = 0;
        this.datos.totalErrorPorDuplicado = 0;

        this.datos.listado.forEach(element => {
          if (element.errorPorTotales) {
            this.datos.totalErrorPorTotales = this.datos.totalErrorPorTotales + 1;
            this.datos.resultadoErrores = this.datos.resultadoErrores + 1;
          }
          if (element.errorPorFaltaDatos) {
            this.datos.totalErroresPorFaltaDatos = this.datos.totalErroresPorFaltaDatos + 1;
            this.datos.resultadoErrores = this.datos.resultadoErrores + 1;
          }
          if (element.errorPorMultiPagina) {
            this.datos.totalErroresPorMultiPagina = this.datos.totalErroresPorMultiPagina + 1;
            this.datos.resultadoErrores = this.datos.resultadoErrores + 1;
          }
          if (element.errorPorNumFactura) {
            this.datos.totalErroresPorNumFactura = this.datos.totalErroresPorNumFactura + 1;
            this.datos.resultadoErrores = this.datos.resultadoErrores + 1;
          }
          if (element.errorPorFaltaIVA) {
            this.datos.totalErroresPorFaltaIVA = this.datos.totalErroresPorFaltaIVA + 1;
            this.datos.resultadoErrores = this.datos.resultadoErrores + 1;
          }
          if (element.errorPorFaltaCompania) {
            this.datos.totalErroresPorFaltaCompania = this.datos.totalErroresPorFaltaCompania + 1;
            this.datos.resultadoErrores = this.datos.resultadoErrores + 1;
          }
          if (element.errorPorDocDuplicado) {
            this.datos.totalErrorPorDuplicado = this.datos.totalErrorPorDuplicado + 1;
            this.datos.resultadoErrores = this.datos.resultadoErrores + 1;
          }
        });

        console.log(datos);

        this.loading = false;
        this.cargandoResultados = false;
        this.formularioCompletado = true;

      }, (error) => {
        console.log(error);
        this.loading = false;
        this.mostrarError = true;
      });
  }

  fechaChange($event) {

    let fechaall: string = "";

    if (typeof ($event) === "string") {
      fechaall = $event;
    } else if (typeof ($event) === "number") {
      fechaall = $event.toString();
    } else if ($event.target != undefined && $event.target != null) {
      fechaall = $event.target.value;
    }

    let format = 'dd/mm/yy';

    let resultado = "";
    let fecha = "";

    if (fechaall.length == 10) {
      while (fechaall.indexOf("/") > -1) {
        fechaall = fechaall.replace("/", "");
      }
    }

    let diasMes = fechaall.substring(0, 2);
    let mesFecha = fechaall.substring(2, 4);

    if (fechaall) {
      if (fechaall.length > 8 || fechaall.length < 4 || fechaall.length == 7 || fechaall.length == 5) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(diasMes) > 31 || parseInt(diasMes) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(mesFecha) > 12 || parseInt(mesFecha) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else {

        if (fechaall.indexOf('/') >= 0 && fechaall != "") {

          let fechaArray = fechaall.split('/');

          let dia = fechaArray[0];
          dia = dia.length < 2 ? "0" + (dia) : dia;

          let mes = fechaArray[1];
          mes = mes.length < 2 ? "0" + (mes) : mes;

          let hoy = new Date;

          let anio = fechaArray[2];

          if (anio) {
            switch (anio.length) {
              case 4:
                anio = anio; break;
              case 2:
                anio = "20" + anio; break;
              default:
                anio = '';
            }

          } else { anio = hoy.getFullYear().toString(); }

          if (dia != '' && mes != '' && anio != '') {
            fecha = dia + mes + anio;
          }

        } else {
          fecha = fechaall;
        }

        if (this.isNumber(fecha)) {

          if (format === 'dd/mm') {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + fecha.substring(4, 8);
                break;
              case 6:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

          }
          else {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + fecha.substring(4, 8);
                break;
              case 6:
                var anio = fecha.substring(4, 6);

                if (parseInt(anio.substring(0, 1)) <= 9 && parseInt(anio.substring(0, 1)) >= 5) {
                  anio = "19" + anio;
                } else {
                  anio = "20" + anio;
                }
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

            moment.locale("es");
            var fechaValidacion = moment().format(resultado);

            if (!moment(fechaValidacion, 'DD-MM-YYYY').isValid()) {

              this.toastr.error('Fecha incorrecta.');

              resultado = "";

            } else {

              resultado = fechaValidacion;
            }
          }
        } else {
          this.toastr.error('Fecha incorrecta.');
          resultado = "";
        }

      }
    }

    this.formulario.patchValue({
      fecha: resultado
    });
  }

  private GetFechaInteger(date: string): number {
    if (date == "" || date == undefined) {
      return 0;
    }

    if (date.length != 10) {
      return 0;
    }

    let dia = Number(date.substr(0, 2));
    let mes = Number(date.substr(3, 2));
    let ano = Number(date.substr(6, 4));

    if (Number.isNaN(dia) == true || dia == undefined || Number.isNaN(mes) == true || mes == undefined || Number.isNaN(ano) == true || ano == undefined) {
      return 0;
    }

    return ano * 10000 + mes * 100 + dia;
  }

  public SetFechaString(date: number): string {
    let resultado: string = "";

    if (Number.isNaN(date) == true || date == undefined || date == null) {
      return "";
    }

    if (date == 0) {
      return "";
    }

    let dia: number = 0;
    let mes: number = 0;
    let ano: number = 0;

    ano = this.redondearExp(date / 10000, 0);
    date = date - (ano * 10000);
    mes = this.redondearExp(date / 100, 0);
    dia = date - (mes * 100);

    if (ano == 0 || mes == 0 || dia == 0) {
      return "";
    }

    resultado = dia.toString().padStart(2, "0") + "/" + mes.toString().padStart(2, "0") + "/" + ano.toString();

    return resultado;
  }

  private toExp(numero: Number, digitos: number): number {
    let arr = numero.toString().split("e");
    let mantisa = arr[0], exponente = digitos;
    if (arr[1]) exponente = Number(arr[1]) + digitos;
    return Number(mantisa + "e" + exponente.toString());
  }

  private redondearExp(numero: number, digitos: number, masEspaciado: boolean = false): number {

    let absNumero = Math.abs(numero);
    let signo = Math.sign(numero);

    if (masEspaciado) {
      let n = Math.floor(Math.log2(absNumero));
      let spacing = Math.pow(2, n) * Number.EPSILON;
      if (spacing < Math.pow(10, -digitos - 1)) {
        absNumero += spacing;
      }
    }

    let entero = Math.round(this.toExp(absNumero, digitos));
    return signo * this.toExp(entero, -digitos);
  }

  private isNumber(numero) {
    if (this.isDecimal(numero) || !isNaN(parseInt(numero))) {
      return true;
    }
    return false;
  }

  private isDecimal(numero) {
    if (typeof numero === 'undefined') {
      return false;
    } else {
      numero = Math.abs(numero);
    }

    var pattern = /^\d+(\.\d*)?$/;
    if (pattern.test(numero)) {
      return true;
    }
    else {
      return false;
    }
  }

  public convertThousandsFixed(number: any, digits: string) {

    if (typeof number === 'undefined') {
      number = 0.0;
    }

    if (this.isDecimal(number) === true) {
      number = parseFloat((Math.round(number * 100) / 100).toString()).toFixed(2);

      number = number.toString().replace('.', ',');
    }

    var value = number.toString().split('.').join('');
    var numbers = value.split(',');
    var enter = numbers[0];
    var new_number = '';

    var amount = enter.toString();
    amount = amount.split('').reverse();
    var output = '';
    for (var i = 0; i <= amount.length - 1; i++) {
      output = amount[i] + output;
      if ((i + 1) % 3 === 0 && (amount.length - 1) !== i) output = '.' + output;
    }

    if (digits !== '0') {

      if (numbers.length === 1) {
        if (numbers[0] === '') {
          new_number = output;
        } else {
          new_number = output + ',00';
        }
      } else {
        if (numbers[1] === '') {
          new_number = output + ',00';
        } else {
          if (numbers[1].substring(0, 2).length === 1) {
            new_number = output + ',' + numbers[1].substring(0, 1) + '0';
          } else {
            new_number = output + ',' + numbers[1].substring(0, digits);
          }
        }
      }
      if (new_number.substring(0, 1) === '-' && new_number.substring(1, 2) === '.') {
        new_number = new_number.replace('.', '');
      }
      if (new_number === '0,0000') {
        new_number = '0,00';
      }
    } else {
      new_number = output;
      if (numbers[1] !== undefined) {

        new_number = new_number + ',' + numbers[1];
      }
    }
    if (digits === '0') {

      numbers = new_number.split(',');
      if (Number(numbers[1]) === 0) {

        new_number = numbers[0];
      }
    }

    return new_number;
  }

}
